import React from 'react';
import { CtaButton } from './CtaButton';
export function FinalMentorSection() {
  return <section className="px-6 py-8 flex flex-col items-center text-center max-w-7xl mx-auto" data-id="element-126">
      <h2 className="font-sans font-bold text-3xl md:text-6xl text-brand-navy mb-8" data-id="element-127">
        ¿Quién será tu <br data-id="element-128" /> <span className="font-bold" data-id="element-129">mentora? 💘</span>
      </h2>

      <div className="w-full max-w-5xl grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-12" data-id="element-130">
        <div className="flex justify-center" data-id="element-131">
          {/* Mentor Image with rounded corners */}
          <div className="w-full max-w-[340px] md:max-w-md rounded-[3rem] overflow-hidden shadow-xl" data-id="element-132">
            <img src="https://cdn.magicpatterns.com/uploads/dJYqtyfy5jS2DoahihtEHT/pasted-image.jpg" alt="Brenda Hormaechea Mentora" className="w-full h-auto block" data-id="element-133" />
          </div>
        </div>

        <div className="flex flex-col items-center md:items-start text-center md:text-left space-y-6" data-id="element-134">
          <div className="space-y-4" data-id="element-135">
            <h3 className="font-sans font-bold text-2xl md:text-4xl text-brand-navy" data-id="element-136">
              Brenda Hormaechea
            </h3>

            <p className="font-sans text-brand-navy text-lg md:text-xl leading-relaxed" data-id="element-137">
              <strong className="font-bold text-brand-navy/80" data-id="element-138">Creadora</strong>{' '}
              de Contenido <strong className="font-bold" data-id="element-139">UGC</strong>, Travel
              Influencer, Info-productora,{' '}
              <strong className="font-bold" data-id="element-140">Embajadora</strong> de viajes y
              Experta en{' '}
              <strong className="font-bold" data-id="element-141">Marketing Digital</strong>, con +10
              años de experiencia. Creadora{' '}
              <strong className="font-bold text-brand-navy underline" data-id="element-142">
                @entualma.viajes
              </strong>
            </p>
          </div>

          <div className="w-full max-w-[340px] md:max-w-md md:scale-110 md:origin-left" data-id="element-143">
            <CtaButton variant="gold" data-id="element-144">¡SI, QUIERO INSCRIBIRME!</CtaButton>
          </div>
        </div>
      </div>
    </section>;
}